<p-sidebar
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  position="right"
  [style]="{ width: '720px' }"
  [modal]="false"
  [showCloseIcon]="true"
  [blockScroll]="false"
  [closeOnEscape]="true"
  [appendTo]="'body'"
>
  <ng-template pTemplate="header">
    <afoone-wxrl-form-header
      [title]="'WXRL.SCHEMA.EDIT_FORMULA' | translate"
      [activeTab]="'Fórmula'"
    >
    </afoone-wxrl-form-header>
  </ng-template>

  <div class="drawer-content header-form-grid" [formGroup]="formulaForm">
    <label for="condition" class="header-label">{{ "WXRL.RULE.FORM.FORMULA" | translate }}</label>
    <afoone-wxrl-formula-editor
      formControlName="condition"
      [conditions]="conditions"
      class="header-input"
    ></afoone-wxrl-formula-editor>

    <span class="header-label"></span>
    <div class="header-field">
      <p-checkbox
        formControlName="negRule"
        inputId="negRule"
        [binary]="true"
      ></p-checkbox>
      <label for="negRule" class="ml-2">{{
        "WXRL.RULE.FORM.NEGADA" | translate
      }}</label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="drawer-footer">
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        (click)="onCancel()"
        severity="secondary"
        [text]="true"
      ></p-button>
      <p-button
        label="Guardar"
        icon="pi pi-check"
        (click)="onSaveAndFinish()"
        [disabled]="formulaForm.invalid"
      ></p-button>
    </div>
  </ng-template>
</p-sidebar>
